import { configureStore } from '@reduxjs/toolkit'
import userReducer from './store/userSlice'
import roleReducer from './store/roleSlice'
import platformReducer from './store/platformSlice'
import leadReducer from './store/LeadSlice'
import settingReducer from './store/settingSlice'
import domainReducer from './store/domainSlice'
import industryReducer from './store/industrySlice'
import clientReducer from './store/clientSlice'
import contactReducer from './store/contactSlice'
import landingPageReducer from './store/LandPageSlice'
import  cookieReducer  from './store/cookieSlice'
import aiContentReducer from './store/aiContentSlice'

export const store = configureStore({
  reducer: { userReducer, roleReducer, platformReducer, leadReducer, settingReducer, domainReducer, industryReducer,clientReducer,contactReducer,landingPageReducer,cookieReducer, aiContentReducer },

})

